import { render, staticRenderFns } from "./ServiceNumberDetail.vue?vue&type=template&id=ac3d715c&scoped=true&"
import script from "./ServiceNumberDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3d715c",
  null
  
)

export default component.exports